import { TextFieldSts } from "staysure-component-library";

import { ContactDetilasEmailSectionProps } from "@/app/components/contact-details/types/contact-details.type";
import RichText from "@/components/atoms/rich-text/rich-text";
import withApplication from "@/components/with-application";
import withBrand from "@/components/with-brand";
import { RenewalPage } from "@/config/app-constant";
import { APPLICATION } from "@/constants";
import { handleFocusScrollContactForm } from "@/utils/scrollUtils";

import { useContactDetailsContext } from "../../../../provider/contact-details.provider";
import { formCmsData } from "../../../../utils/contact-details-page.util";

function ContactDetilasEmailSection({
  brand = "staysure",
  emailRef,
  errorEmailMessage,
}: Readonly<ContactDetilasEmailSectionProps>) {
  const { cmsData, handlers, formValues, validations, setters } =
    useContactDetailsContext();
  const { emailDescription, emailLabel } = formCmsData(cmsData);

  const { handleEmailChange, handleContinue, handleBlur } = handlers;
  const { email } = formValues;
  const { isEmailValid } = validations;
  const { setErrorEmailMessage } = setters;

  return (
    <>
      <div className="">
        {emailDescription && (
          <RichText
            richText={emailDescription}
            className="text-[14px] break-words font-body-font leading-[21px] text-text-body contact-rich-text"
          />
        )}
      </div>

      <button
        ref={emailRef}
        data-testid="contact-email-btn"
        type="button"
        tabIndex={-1}
        onFocus={() => {
          if (emailRef) {
            handleFocusScrollContactForm("emailValue", emailRef);
          }
        }}
        className="mt-spacing-s md:w-[347px] w-full"
      >
        <TextFieldSts
          maxLength={125}
          label={emailLabel}
          id="contact-email"
          data-testid="contact-email-input"
          width="100%"
          state={errorEmailMessage !== "" ? "error" : ""}
          message={errorEmailMessage ?? ""}
          onChange={(e) => handleEmailChange(e)}
          value={email}
          onBlur={(event) => {
            if (
              event.relatedTarget &&
              event.relatedTarget.id === "actionButton2"
            ) {
              handleContinue();
            } else {
              handleBlur(isEmailValid, email, setErrorEmailMessage);
            }
          }}
          brand={brand}
          isDisabled={APPLICATION === RenewalPage}
        />
      </button>
    </>
  );
}
export default withBrand(withApplication(ContactDetilasEmailSection));
